<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="ls-clearfix"></div>
    <label class="ls-float-right" style="position:relative;">
      <i class="fa fa-search seach" aria-hidden="true"></i>
      <input type="search" placeholder="Nome do adquirente" class="ls-sm-margin-right" style="padding-left:40px;" v-model="query"></input>
    </label>
    <h3 class="ls-title-4 ls-sm-margin-left">{{ $t('settings.attributes.select_acquirer') }}</h3>
    <div class="acquirers">
      <div @click="showProcessor(processor)" class="col-md-2" v-for="processor, index in processorList">
        <div class="box-payment-method ls-box ls-board-box shadow-box ls-cursor-pointer col-md-12" >
          <img class="ls-float-left ls-md-margin-bottom ls-md-space image-size" :src="processor.logo">
          <p class="ls-txt-center col-md-12">{{processor.description}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import date from 'src/utils/date'

  export default {
    name: 'transaction',
    components: {
      Regroup,
      Breadcrumb
    },
    data () {
      return {
        showFilter: false,
        date: date,
        index: '',
        inactiveObjects: { show: false },
        activeObjects: { show: false },
        selected: [],
        query: '',
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.payment_acquirer'),
          'paths': {
            0: {
              'title': this.$t('settings.main.select_payment_method'),
              'path': '/settings/payment_settings'
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters(['paymentMethods', 'pagination', 'processors']),
      processorList: function () {
        return this.filterProcessors(this.query)
      }
    },
    methods: {
      ...mapMutations(['clearFlash', 'clearPaymentMethods', 'addFlash', 'setPaymentMethod']),
      ...mapActions(['loadProcessors']),
      getPaymentMethods () {
        this.$loader.show()
        this.loadProcessors().then(this.afterLoad)
      },
      afterLoad () {
        this.$loader.hide()
      },
      showProcessor (processor) {
        this.$router.push('/settings/payment_settings/' + processor.name + '/show')
      },
      filterProcessors: function (value) {
        if (!this.processors.length) return
        return this.processors.filter(function (item) {
          return item.description.toLowerCase().includes(value.toLowerCase())
        })
      }
    },
    mounted () {
      this.getPaymentMethods()
    }
  }
</script>
<style scoped>
  .shadow-box:hover {
    box-shadow: 1px 1px 5px #888888;
    transition: opacity 0.3s ease-in-out;
  }
  .active {
    color: #388f39!important;
    background-color: #b2e1b3!important;
  }
  .inactive {
    color: #d75553!important;
    background-color: #fff4f4!important;
  }
  .acquirers {
    display: flex;
    flex-wrap: wrap;
  }
  .image-size {
    width: 180px;
    height: 150px;
  }
  .seach {
    font-size:20px;
    position:absolute; top:7px; left:10px;
  }
  .box-payment-method{
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// IndexPaymentSettings.vue?93898e8c